import { createContext } from "react";

export const PostersContext = createContext();
